import React from 'react' // eslint-disable-line no-unused-vars
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'
import { connect } from 'react-redux'

const PatientDisclosureModal = ({ isModalOpen, toggle, pageContent }) =>
    <Modal
        className='patient-disclosure-popup-modal'
        isOpen={isModalOpen}
        backdrop
        keyboard={false}
        wrapClassName='modal-primary'
        size='lg'
    >
        <ModalBody>
            <div>
                {pageContent.content.page.PatientDisclosure.patientDisclosureText}
            </div>
            <div className='patient-disclosure-popup-button'>
                <button
                    type='button'
                    onClick={
                        toggle
                    }
                    className='btn btn-primary submit-button btn-rounded'
                >
                    {pageContent.content.page.PatientDisclosure.agreeButton}
                </button>
            </div>
        </ModalBody>
    </Modal>

const mapStateToProps = state => ({
    pageContent: state.pageContent
})

export default connect(mapStateToProps)(PatientDisclosureModal)


// WEBPACK FOOTER //
// ./src/mi-app/modals/PatientDisclosureModal.js